import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDrawer } from 'src/hooks/useDrawer';
import { useWindowSize } from 'react-easyrocket';
import 'src/components/Games/GamesControlPanel/styles.css';

interface GameCategoriesItemProps extends React.HTMLAttributes<HTMLDivElement> {
  image: JSX.Element;
  content: string;
  param: string;
}

export const GameCategoriesItem: FC<GameCategoriesItemProps> = ({
  image,
  content,
  param,
  ...rest
}) => {
  const { t } = useTranslation();
  const { closeDrawer } = useDrawer();
  const { isMobileLayout } = useWindowSize();

  const handleClickCategory = () => {
    isMobileLayout && closeDrawer();
  };

  return (
    <div
      {...rest}
      className="flex w-full items-center gap-[5px] bg-background_categories_item_sidebar p-[12px] rounded-[10px] border-[1px] border-background_categories_item_sidebar border-solid hover:border-border_categories_item_sidebar"
      onClick={handleClickCategory}>
      <div className="game-category-item-icon">{image}</div>
      <p className="game-category-item-content text-text-secondary flex flex-col">{t(content)}</p>
    </div>
  );
};
